export default "__VITE_ASSET__B9y$Zbom__"